import * as React from 'react';
import Button from '@mui/material/Button';

export default function RankingMenu() {

  const handleClick = (event) => {
    console.log('Gestionar Ranking clicked');
  };

  return (
    <div>
      <Button
        id='basic-button'
        onClick={handleClick}
      >
        Gestionar Ranking
      </Button>
    </div>
  );
}
